import React from 'react';
import { useTheme } from '../App';
import { Logo } from '../components/Logo';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 36 }}>
    <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--cyan)', marginBottom: 12, fontFamily: 'Orbitron', letterSpacing: 1 }}>
      {title}
    </h2>
    <div style={{ color: 'var(--text)', lineHeight: 1.75, fontSize: 14 }}>
      {children}
    </div>
  </div>
);

const Sub = ({ title, children }) => (
  <div style={{ marginBottom: 20 }}>
    <h3 style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 8, marginTop: 16 }}>{title}</h3>
    {children}
  </div>
);

const Table = ({ rows }) => (
  <div style={{ overflowX: 'auto', marginBottom: 12 }}>
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
      <thead>
        <tr>
          {rows[0].map((cell, i) => (
            <th key={i} style={{ textAlign: 'left', padding: '8px 12px', background: 'var(--glass)', color: 'var(--cyan)', borderBottom: '1px solid var(--glass-border2)', fontWeight: 600, whiteSpace: 'nowrap' }}>
              {cell}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.slice(1).map((row, i) => (
          <tr key={i} style={{ borderBottom: '1px solid var(--glass-border)' }}>
            {row.map((cell, j) => (
              <td key={j} style={{ padding: '8px 12px', color: 'var(--text2)', verticalAlign: 'top' }}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default function Datenschutz() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '40px 20px 80px' }}>
      <button
        onClick={toggleTheme}
        style={{ position: 'fixed', top: 20, right: 20, zIndex: 10, background: 'var(--glass)', border: '1px solid var(--glass-border2)', borderRadius: 20, padding: '6px 14px', fontSize: 12, fontFamily: 'Outfit', color: 'var(--text2)', cursor: 'pointer', backdropFilter: 'blur(12px)' }}
      >
        {theme === 'dark' ? '☀ Hell' : '◑ Dunkel'}
      </button>

      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <Logo size={36} />
          <h1 style={{ fontFamily: 'Orbitron', fontSize: 22, fontWeight: 700, color: 'var(--text)', marginTop: 20, marginBottom: 8 }}>
            Datenschutzerklärung
          </h1>
          <p style={{ color: 'var(--text2)', fontSize: 13 }}>
            KI-Content-Tool · app.look4more.de · Stand: Juni 2026
          </p>
        </div>

        <div className="glass-card" style={{ padding: '32px 36px', borderRadius: 20 }}>

          <Section title="1. Verantwortlicher">
            <p>Verantwortlich im Sinne der DSGVO für die Verarbeitung personenbezogener Daten in diesem Dienst ist:</p>
            <div style={{ margin: '16px 0', padding: '16px 20px', background: 'var(--glass)', borderRadius: 12, border: '1px solid var(--glass-border)', lineHeight: 2 }}>
              <strong style={{ color: 'var(--text)' }}>look4more</strong><br />
              Steffen Woik<br />
              Neustrelitz<br />
              Deutschland<br />
              E-Mail: <a href="mailto:kontakt@look4more.de" style={{ color: 'var(--cyan)' }}>kontakt@look4more.de</a>
            </div>
            <p style={{ color: 'var(--text2)', fontSize: 13 }}>
              Hinweis: Dies ist ein passwortgeschütztes SaaS-Tool. Die Datenschutzerklärung richtet sich an registrierte Nutzer.
            </p>
          </Section>

          <Section title="2. Welche Daten verarbeiten wir">
            <Sub title="2.1 Registrierung und Account">
              <p>Bei der Registrierung erheben wir:</p>
              <ul style={{ paddingLeft: 20, marginTop: 8, color: 'var(--text2)' }}>
                <li>Name und E-Mail-Adresse</li>
                <li>Passwort (verschlüsselt gespeichert, bcrypt)</li>
                <li>Zeitpunkt der Registrierung</li>
              </ul>
              <p style={{ marginTop: 8 }}>
                Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
              </p>
            </Sub>

            <Sub title="2.2 Content-Erstellung (Posts und Bilder)">
              <p>
                Zur Generierung von Social-Media-Texten und Bildern werden von dir eingegebene Themen, Prompts
                und Firmenprofilangaben an externe KI-Anbieter übermittelt. Diese Daten enthalten keine
                personenbezogenen Daten von Dritten, solange du keine solchen in Prompts eingibst.
              </p>
              <p style={{ marginTop: 8 }}>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
            </Sub>

            <Sub title="2.3 Firmenprofil und Voice Profile">
              <p>
                Angaben zu deinem Unternehmen (Name, Branche, Zielgruppe, Schreibstil) werden in unserer
                Datenbank gespeichert und ausschließlich zur Personalisierung der Content-Generierung genutzt.
              </p>
              <p style={{ marginTop: 8 }}>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
            </Sub>

            <Sub title="2.4 Google Analytics (GA4) — optional">
              <p>
                Wenn du die GA4-Integration aktivierst, autorisierst du unser Tool, lesenden Zugriff auf deine
                Google Analytics Property zu erhalten. Dafür wird ein OAuth-2.0-Token gespeichert. Die Daten
                (Besucher, Sessions, Seitenaufrufe) werden ausschließlich für die Darstellung in deinem Dashboard
                und im Monatsbericht genutzt. Details zur Datenweitergabe, u.a. an unsere KI-Textgenerierung
                für den Monatsbericht, findest du in Abschnitt 4.
              </p>
              <p style={{ marginTop: 8 }}>Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung durch aktive Verbindung)</p>
              <p style={{ marginTop: 8 }}>Du kannst die Verbindung jederzeit unter Einstellungen → Analytics trennen. Der Token wird dann gelöscht.</p>
            </Sub>

            <Sub title="2.5 Monatsbericht per E-Mail">
              <p>
                Einmal monatlich versenden wir eine Zusammenfassung deiner Aktivitäten im Tool an deine
                registrierte E-Mail-Adresse. Der Versand erfolgt über den Dienst Resend.
              </p>
              <p style={{ marginTop: 8 }}>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsbestandteil)</p>
            </Sub>

            <Sub title="2.6 Veröffentlichung auf Social-Media-Plattformen — optional">
              <p>
                Wenn du Beiträge über das Tool veröffentlichst, werden diese über den Dienst Upload-Post an die
                jeweiligen Plattformen (Instagram, Facebook, LinkedIn usw.) übertragen. Es werden nur die Inhalte
                übermittelt, die du zur Veröffentlichung freigibst.
              </p>
              <p style={{ marginTop: 8 }}>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
            </Sub>
          </Section>

          <Section title="3. Eingesetzte Drittanbieter">
            <p style={{ marginBottom: 16, color: 'var(--text2)' }}>
              Für den Betrieb des Tools nutzen wir folgende externe Dienste. Mit allen Anbietern bestehen
              Auftragsverarbeitungsverträge (AVV) gemäß Art. 28 DSGVO.
            </p>
            <Table rows={[
              ['Dienst', 'Anbieter', 'Zweck', 'Datenübertragung'],
              ['Claude AI', 'Anthropic PBC, USA', 'Textgenerierung', 'USA (SCC)'],
              ['Gemini', 'Google Ireland Ltd., Irland', 'Bildgenerierung', 'EU/EWR'],
              ['Google Analytics', 'Google Ireland Ltd., Irland', 'GA4-Integration (optional)', 'EU/EWR'],
              ['Google OAuth', 'Google Ireland Ltd., Irland', 'GA4-Verbindung', 'EU/EWR'],
              ['Upload-Post', 'Upload-Post, Deutschland', 'Social-Media-Publishing', 'EU'],
              ['Resend', 'Resend Inc., USA', 'E-Mail-Versand', 'USA (SCC)'],
              ['IONOS VPS', 'IONOS SE, Deutschland', 'Server-Hosting, Datenbank', 'Deutschland'],
            ]} />
            <p style={{ fontSize: 13, color: 'var(--text2)', marginTop: 8 }}>
              SCC = EU-Standardvertragsklauseln als Grundlage für Drittlandtransfer gemäß Art. 46 Abs. 2 lit. c DSGVO.
              Die KI-Anbieter verwenden eingegebene Daten nach eigenen Angaben nicht zum Training allgemeiner Modelle.
            </p>
          </Section>

          <Section title="4. Google Analytics 4 Integration">
            <p>
              Diese Anwendung ermöglicht die optionale Verbindung mit Google Analytics 4 über OAuth 2.0.
              Dabei wird ausschließlich der Scope <code style={{ background: 'var(--glass)', padding: '1px 6px', borderRadius: 4, fontSize: 13 }}>analytics.readonly</code> verwendet,
              das Tool kann deine GA4-Daten nur lesen, niemals verändern.
            </p>
            <ul style={{ paddingLeft: 20, marginTop: 12, color: 'var(--text2)', lineHeight: 2 }}>
              <li><strong style={{ color: 'var(--text)' }}>Zweck:</strong> Anzeige der eigenen GA4-Daten (Sessions, Nutzer, Seitenaufrufe, Top-Seiten) im persönlichen Dashboard sowie im monatlichen Bericht</li>
              <li><strong style={{ color: 'var(--text)' }}>Datenspeicherung:</strong> Die abgerufenen Analytics-Daten werden nicht dauerhaft gespeichert</li>
              <li><strong style={{ color: 'var(--text)' }}>Weitergabe:</strong> Die abgerufenen GA4-Rohdaten werden nicht an Dritte weitergegeben. Für den monatlichen Bericht werden ausschließlich bereits aggregierte Kennzahlen (Gesamtzahl Sessions, Nutzer, Seitenaufrufe, neue Nutzer je Monat, keine Einzelbesucher- oder Rohdaten) an Claude Haiku (Anthropic) übermittelt, um daraus automatisiert Text-Insights zu erzeugen. Es werden keine GA4-Daten zum Training von KI-Modellen verwendet oder an weitere Dritte weitergegeben.</li>
              <li><strong style={{ color: 'var(--text)' }}>Zugriff:</strong> Die Daten sind ausschließlich für den authentifizierten Nutzer sichtbar</li>
              <li><strong style={{ color: 'var(--text)' }}>Verbindung trennen:</strong> Du kannst die Google-Verbindung jederzeit unter <strong style={{ color: 'var(--text)' }}>Einstellungen → Analytics</strong> trennen, der gespeicherte Token wird dabei sofort gelöscht</li>
            </ul>
            <p style={{ marginTop: 12, fontSize: 13, color: 'var(--text2)' }}>
              Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung durch aktive Verbindung). Es gelten zusätzlich die{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--cyan)' }}>
                Datenschutzbestimmungen von Google
              </a>.
            </p>
            <p style={{ marginTop: 16, padding: '14px 18px', background: 'var(--glass)', borderRadius: 12, border: '1px solid var(--glass-border)', fontSize: 13 }}>
              <strong style={{ color: 'var(--text)' }}>Limited Use Compliance Statement:</strong> Die Nutzung und Übermittlung von über Google-APIs erhaltenen Informationen
              durch dieses Tool entspricht der{' '}
              <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--cyan)' }}>
                Google API Services User Data Policy
              </a>, einschließlich der Limited Use-Anforderungen. Über den Scope <code style={{ background: 'var(--glass2)', padding: '1px 6px', borderRadius: 4 }}>analytics.readonly</code> erhaltene
              GA4-Daten werden ausschließlich für die oben beschriebene Anzeige- und Reporting-Funktion verwendet, nicht für Werbezwecke,
              nicht zur Bonitäts-/Kreditprüfung, nicht zum Training allgemeiner KI-Modelle und nicht zum Verkauf oder zur Weitergabe an Dritte
              außerhalb der genannten Kernfunktion.
            </p>
          </Section>

          <Section title="5. Speicherdauer">
            <ul style={{ paddingLeft: 20, color: 'var(--text2)', lineHeight: 2 }}>
              <li>Account-Daten: bis zur Kündigung des Accounts, danach 30 Tage Löschfrist</li>
              <li>Generierte Posts: bis zur manuellen Löschung durch den Nutzer</li>
              <li>GA4-Zugangsdaten (Token): bis zum Trennen der Verbindung</li>
              <li>Monatsberichte: kein Archiv, einmalige Zustellung per E-Mail</li>
              <li>Log-Daten (Serverfehler): max. 30 Tage</li>
            </ul>
          </Section>

          <Section title="6. Authentifizierung und Sitzungsverwaltung">
            <p>
              Die Anmeldung erfolgt über JWT-Tokens (JSON Web Tokens), die im lokalen Speicher (localStorage)
              deines Browsers gespeichert werden. Es werden keine Tracking-Cookies oder Analyse-Cookies gesetzt.
              Das einzige Token dient ausschließlich der Sitzungsauthentifizierung und enthält deine Nutzer-ID
              sowie dein Zugangs-Tier.
            </p>
            <p style={{ marginTop: 8 }}>
              Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren Login)
              sowie § 25 Abs. 2 Nr. 2 TTDSG (technisch notwendig).
            </p>
          </Section>

          <Section title="7. Einsatz von KI — Transparenzhinweis">
            <p>
              Texte und Bilder, die du über dieses Tool erzeugst, werden mithilfe externer KI-Systeme
              (Claude von Anthropic, Gemini von Google) generiert. Die finale Entscheidung über Inhalt und
              Veröffentlichung liegt ausschließlich bei dir. Du bist als Nutzer selbst verantwortlich für
              die rechtliche Prüfung und ggf. Kennzeichnungspflicht (z.B. Werbekennzeichnung) der generierten
              Inhalte auf Social-Media-Plattformen.
            </p>
          </Section>

          <Section title="8. Deine Rechte">
            <p style={{ marginBottom: 12 }}>Du hast nach DSGVO folgende Rechte gegenüber uns:</p>
            <Table rows={[
              ['Recht', 'Bedeutung'],
              ['Auskunft (Art. 15)', 'Welche Daten von dir gespeichert sind'],
              ['Berichtigung (Art. 16)', 'Korrektur unrichtiger Daten'],
              ['Löschung (Art. 17)', 'Löschung deines Accounts und aller Daten'],
              ['Einschränkung (Art. 18)', 'Verarbeitung einschränken lassen'],
              ['Datenportabilität (Art. 20)', 'Daten in maschinenlesbarem Format erhalten'],
              ['Widerspruch (Art. 21)', 'Verarbeitung auf Basis berechtigtem Interesse widersprechen'],
              ['Widerruf der Einwilligung', 'GA4-Verbindung jederzeit in den Einstellungen trennen'],
            ]} />
            <p style={{ marginTop: 12 }}>
              Anfragen richtest du an:{' '}
              <a href="mailto:kontakt@look4more.de" style={{ color: 'var(--cyan)' }}>kontakt@look4more.de</a>
            </p>
            <p style={{ marginTop: 8 }}>
              Du hast außerdem das Recht, Beschwerde bei einer Datenschutzaufsichtsbehörde einzulegen.
              Zuständig ist das Landesamt für innere Verwaltung Mecklenburg-Vorpommern (Datenschutzabteilung),
              da look4more in Neustrelitz ansässig ist.
            </p>
          </Section>

          <Section title="9. Datensicherheit">
            <p>
              Alle Datenübertragungen zwischen Browser und Server erfolgen verschlüsselt über HTTPS/TLS.
              Der Server befindet sich in einem deutschen Rechenzentrum (IONOS, Frankfurt). Passwörter werden
              ausschließlich als bcrypt-Hash gespeichert — das Klartextpasswort ist uns nicht bekannt.
            </p>
          </Section>

          <Section title="10. Änderungen dieser Datenschutzerklärung">
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung bei wesentlichen Änderungen des Tools oder
              der Rechtslage zu aktualisieren. Du wirst über bedeutende Änderungen per E-Mail informiert.
              Das Datum der letzten Aktualisierung steht oben auf dieser Seite.
            </p>
          </Section>

          <div style={{ marginTop: 40, paddingTop: 24, borderTop: '1px solid var(--glass-border)', textAlign: 'center' }}>
            <p style={{ fontSize: 12, color: 'var(--text2)' }}>
              Hinweis: Dieses Dokument wurde sorgfältig erstellt, ersetzt jedoch keine individuelle Rechtsberatung.
              Vor dem Produktivbetrieb empfehlen wir eine Prüfung durch einen auf IT-Recht spezialisierten Anwalt.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 24, marginTop: 20, flexWrap: 'wrap' }}>
              <a href="/login" style={{ color: 'var(--cyan)', fontSize: 13, textDecoration: 'none' }}>
                ← Zurück zum Login
              </a>
              <a href="https://look4more.de/impressum" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text2)', fontSize: 13, textDecoration: 'none' }}>
                Impressum →
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
